<template>
  <div>
    <label class="form-control-label" for="dropzone">Image</label>
    <div id="dropzone">
      <div class="preview" v-if="imageData.length > 0">
        <img :src="imageData" v-if="imageData.length > 0">
        <img :src="item.url" v-else>
      </div>

      <div class="message" v-else>
        <h5>
          Drop image here or click to upload.
          <div id="file-error" class="error">
            <span v-if="errorMessage">{{errorMessage}}</span>
            <span v-else>&nbsp;</span>
          </div>
        </h5>
      </div>

      <input id="file-input" class="file" type="file" @change="previewImage" accept="image/*">
    </div>
  </div>
</template>
<script>
const FILE_SIZE_MAX = 2 * 1024 * 1024;
const FILE_TYPES = ["image/png", "image/gif", "image/jpeg"];

export default {
  name: "vue-ez-s3-image",
  props: ["item"],
  data() {
    return {
      errorMessage: null,
      imageData: []
    };
  },
  mounted() {},
  methods: {
    previewImage: function(event) {
      // Reference to the DOM input element
      this.imageData = [];
      this.errorMessage = null;
      const input = event.target;
      const element = document.getElementById("dropzone");

      // Validation
      if (input.files && input.files[0]) {
        if (!FILE_TYPES.includes(input.files[0].type)) {
          this.errorMessage = "Invalid file type.";
        }
        if (Math.round(input.files[0].size) > FILE_SIZE_MAX) {
          this.errorMessage = `Please select a file less than ${Math.round(
            FILE_SIZE_MAX / 1024 / 1024
          )} meg.`;
        }
        if (this.errorMessage) {
          input.value = "";
        }
      }

      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData = e.target.result;
          this.item.file = input.files[0];
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);

        element.classList.add("dropped");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/_global";

#dropzone {
  display: table;
  background-color: $gray-100;
  border: 2px dashed $gray-500;
  color: $gray-500;
  height: 206px;
  width: 100%;
  text-align: center;
  .message {
    display: table-cell;
    vertical-align: middle;
    padding-top: 2em;
  }
  .preview {
    display: table-cell;
    vertical-align: middle;
    height: 20px;
  }
  .error {
    font-size: 0.875em;
    color: red;
  }
  .file {
    width: 100%;
    cursor: pointer;
    position: absolute;
    opacity: 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  &.hover {
    border: solid #fe5;
    color: #fe5;
  }
  &.dropped {
    border: solid $gray-300;
  }
}
</style>
